import { useEffect, useRef, useState } from 'react';

export default function PingStream ({ dataChannel }) {

    const [meanLatency, setMeanLatency] = useState(0);
    const lastTimeRef = useRef(Date.now());
    const historyRef = useRef({
        currentIndex: 0,
        values: [null, null, null, null, null]
    });

    useEffect(() => {
        dataChannel.onmessage = function (event) {
            const history = historyRef.current;
            const now = Date.now();
            const latency = now - lastTimeRef.current;

            history.values[history.currentIndex] = latency;
            history.currentIndex = (history.currentIndex + 1) % history.values.length;

            let sum = 0.0;
            let nbrValues = 0;
            for(const index in history.values) {
                const value = history.values[index];
                if(value) {
                    sum += value;
                    nbrValues++;
                }
            }

            historyRef.current = history;

            if(history.currentIndex === 0) {
                setMeanLatency(sum / nbrValues);
            }

            window.setTimeout(function() {
                if(dataChannel.readyState === 'open') {
                    lastTimeRef.current = Date.now();
                    dataChannel.send(event.data);
                }
            }, 100);
        }
    }, [dataChannel]);

    return <>
    <div className="col-6 text-center p-2">
        <p>Ping is: {meanLatency}</p>
    </div>
    </>
}
